import React from "react";
import { ArrowRight, MessageCircle } from "lucide-react";
import { waUrl } from "../lib/api";

export default function FinalCTA() {
    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <section className="bg-white py-20 md:py-28" data-testid="final-cta-section">
            <div className="max-w-5xl mx-auto px-6 md:px-12">
                <div className="bg-gradient-to-br from-[#F5A623] via-[#F5A623] to-[#D98F1B] rounded-3xl p-10 md:p-14 lg:p-16 relative overflow-hidden">
                    <div className="absolute -top-32 -right-32 w-96 h-96 bg-white/15 rounded-full blur-3xl pointer-events-none" />
                    <div className="absolute -bottom-20 -left-20 w-72 h-72 bg-[#0A1A2F]/10 rounded-full blur-3xl pointer-events-none" />
                    <div className="relative text-center max-w-3xl mx-auto">
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A1A2F] leading-tight tracking-tight">
                            Masih Bingung Pilih Negara, Jurusan, atau Kampus?
                        </h2>
                        <p className="mt-5 text-base sm:text-lg text-[#0A1A2F]/80 leading-relaxed">
                            Mulai dari assessment gratis. Tim Gantari Edu akan membantu memetakan pilihan yang paling realistis untuk profil, budget, dan tujuanmu.
                        </p>
                        <div className="mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
                            <button
                                onClick={() => scrollTo("smart-search")}
                                data-cta="cta_final_assessment"
                                data-testid="final-cta-assessment"
                                className="inline-flex items-center justify-center gap-2 bg-[#0A1A2F] text-white hover:bg-[#11294A] rounded-full px-8 py-4 font-bold transition-all shadow-xl"
                            >
                                Mulai Assessment Gratis <ArrowRight className="w-4 h-4" />
                            </button>
                            <a
                                href={waUrl()}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-cta="cta_final_whatsapp"
                                data-testid="final-cta-whatsapp"
                                className="inline-flex items-center justify-center gap-2 bg-white text-[#0A1A2F] hover:bg-slate-100 rounded-full px-8 py-4 font-bold transition-all shadow-lg"
                            >
                                <MessageCircle className="w-4 h-4" /> Chat Counselor via WhatsApp
                            </a>
                        </div>
                        <p className="mt-6 text-xs sm:text-sm text-[#0A1A2F]/70">
                            Tidak harus langsung daftar. Konsultasi awal bisa dimulai dari diskusi ringan.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
